/* eslint-disable consistent-return */
import React, { useEffect } from 'react';
import '../../stylesheets/app.scss';
import { Helmet } from 'react-helmet';
import { NavigationBarAndMenu, Footer } from '@library/shared-ui';
import CookieConsent from "react-cookie-consent";
import SearchUiSuggestions from '../SearchUiSuggestions';
import initFullStory from './fullStory';
import { initZendeskWidget } from './zendesk';
import {
  getSessionStorage,
  setSessionStorage,
} from '../../utils/sessionManager';
import { ScreenSizeConfigurator } from '../../../../../library/shared-ui/components/ScreenSizeConfigurator';
import favicon from '../../images/android-chrome-512x512.png';
import { initApollo } from './apollo';
import sezzleTheme from '../../templates/Page/themes';
import styled from 'styled-components';

export const CookieConsentContent = styled.div`
.cookie-consent-content {
  margin: 8px 4px 8px 8px !important;

  @media (max-width: 480px) {
    font-size: 13px;
  }
}

.CookieConsent {
  margin: 20px;
  width: 288px !important;
}
`;

declare const window: any;

const Layout = ({ children, data }) => {
  const showToPercentage = (max) => {
    return Math.floor(Math.random() * Math.floor(max));
  };

  const schema = React.useMemo(
    () =>
      children?.props?.children?.props?.children?.props?.data ||
      children?.props?.data ||
      data,
    [
      children?.props?.children?.props?.children?.props?.data,
      children?.props?.data,
      data,
    ],
  );
  const locales = React.useMemo(
    () =>
      children?.props?.children?.props?.children?.props ||
      children?.props ||
      data,
    [children?.props?.children?.props?.children?.props, children?.props, data],
  );

  useEffect(() => {
    const fullStory = getSessionStorage('fullStory');
    // verifies we are in prod - random initialization of fullstory if new session
    if (process.env.GATSBY_TARGET_ENV === '1' && fullStory !== 'true') {
      if (showToPercentage(10) === 0) initFullStory();
      setSessionStorage('fullStory', 'true');
    }

    initZendeskWidget(process.env.GATSBY_ZENDESK_KEY);
    initApollo(process.env.GATSBY_APOLLO_APP_ID);
  }, []);

  return (
    <ScreenSizeConfigurator>
      <Helmet
        htmlAttributes={{ lang: 'en' }}
        link={[
          {
            rel: 'shortcut icon',
            type: 'image/png',
            href: `${favicon}`,
          },
        ]}
      >
        <meta name="fo-verify" content="0ab3c59e-9b79-4cb3-b5df-1833518fd597" />
      </Helmet>
      {!!schema?.contentfulPageTemplate?.navbarMenuSection && (
        <NavigationBarAndMenu
          featuredLinksMobileMenu={
            schema?.contentfulPageTemplate?.navbarMenuSection
              ?.featuredLinksMobileMenu
          }
          mobileNavigationLinks={
            schema?.contentfulPageTemplate?.navbarMenuSection
              ?.mobileNavigationLinks
          }
          featuredMobileSpot={
            schema?.contentfulPageTemplate?.navbarMenuSection
              ?.featuredMobileSpot
          }
          ctaButtons={
            schema?.contentfulPageTemplate?.navbarMenuSection?.ctaButtons
          }
          logo={schema?.contentfulPageTemplate?.navbarMenuSection?.logo}
          mobileShopMenu={
            schema?.contentfulPageTemplate?.navbarMenuSection?.mobileShopMenu
          }
          navigationLinks={
            schema?.contentfulPageTemplate?.navbarMenuSection?.navigationLinks
          }
          showSearchSuggestions
          searchSuggestions={<SearchUiSuggestions />}
          mobileButton={undefined}
        />
      )}
      <main>{children}</main>
      {!!schema?.contentfulPageTemplate?.footerSection && (
        <Footer
          columns={schema?.contentfulPageTemplate?.footerSection?.columns}
          infoColumn={schema?.contentfulPageTemplate?.footerSection?.infoColumn}
          logoContainer={
            schema?.contentfulPageTemplate?.footerSection?.logoContainer
          }
          bottomRow={schema?.contentfulPageTemplate?.footerSection?.bottomRow}
          pageContext={locales?.pageContext || locales?.allContentfulLocale}
        />
      )}
      <CookieConsentContent>
        <CookieConsent
          location="bottom"
          cookieName="cookieConsent"
          style={{
            background: sezzleTheme.backgroundColor,
            color: '#303030',
            fontFamily: sezzleTheme.buttonFont,
            paddingLeft: '8px',
            paddingTop: '2px',
            paddingBottom: '8px',
            borderRadius: '12px',
            boxShadow: 'rgba(0, 0, 0, 0.16) 0px 4px 16px',
            zIndex: 9999999,
          }}
          contentClasses='cookie-consent-content'
          buttonStyle={{
            color: '#303030',
            background:  sezzleTheme.backgroundColor,
            marginLeft: '0px',
            marginRight: '8px',
          }}
          contentStyle={{
            flex: 10, // large enough to push the x button to the right
          }}
          buttonText="x"
          >
            This website uses essential cookies to offer personalized content based on your data and improve your experience. By using this website you consent to the use of cookies. Learn more about cookies and your choices in our <a target='_blank' style={{ color: '#303030' }} href="https://legal.sezzle.com/privacy/">Privacy Policy</a>.
          </CookieConsent>
        </CookieConsentContent>
    </ScreenSizeConfigurator>
  );
};

export default Layout;
